export default __webpack_public_path__ + "static/media/A.916e4f25.svg";